import React, { useEffect, useState } from "react"
import Cookies from 'js-cookie'
// import { ReactComponent as Computer } from "../images/computer.svg"
import { ReactComponent as Google } from "../images/google.svg"
// import { ReactComponent as GooglePlay } from "../images/google-play.svg"
// import { ReactComponent as Gmail } from "../images/gmail.svg"
import { ReactComponent as EmailFax } from "../images/email-fax.svg"

import { ReactComponent as WebApp } from "../images/web-app.svg"

import { ReactComponent as Windows } from "../images/windows.svg"
import { ReactComponent as MacApp } from "../images/mac-app.svg"
import { ReactComponent as AndroidApp } from "../images/android-app.svg"
import { ReactComponent as Microsoft } from "../images/microsoft.svg"
import { ReactComponent as Slack } from "../images/slack.svg"
import { ReactComponent as Chrome } from "../images/chrome.svg"
import { ReactComponent as FaxApi } from "../images/fax-api.svg"

import { ReactComponent as Legal } from "../images/common/legal.svg"
import { ReactComponent as Education } from "../images/common/education.svg"
import { ReactComponent as Financial } from "../images/common/financial.svg"
import { ReactComponent as Healthcare } from "../images/common/healthcare.svg"
import { ReactComponent as Manufacturing } from "../images/common/manufacturing.svg"
import { ReactComponent as Insurance } from "../images/common/insurance.svg"
import { ReactComponent as SoftwareTech } from "../images/common/software-tech.svg"

import { ReactComponent as Security } from "../images/common/secure.svg"
import { ReactComponent as HipaaFax } from "../images/common/hipaa-fax.svg"
import { ReactComponent as HelpCenter } from "../images/common/help-center.svg"
import { ReactComponent as CustomerStories } from "../images/common/customer-stories.svg"
import { ReactComponent as FAQs } from "../images/common/faq.svg"
import { ReactComponent as ContactSales } from "../images/common/contact-sales.svg"
import axios from "axios"

// import { ReactComponent as Enterprise } from "../images/common/enterprise.svg"
// import { ReactComponent as SmallBusiness } from "../images/common/small-business.svg"

let buildApi=`${process.env.REACT_APP_CONFIG_BASEURL}`

const Header = ({refreshFlag}) => {
  const [visible, setVisible] = useState(true)
  const [userBool, setUserBool] = useState(false);
  const [userName, setUserName] = useState('cocofax');

  const logoutFun = () => {
    Cookies.remove('cocofaxName',{ path: '/',domain: '.cocofax.com' });
    Cookies.remove('cocofaxToken',{ path: '/',domain: '.cocofax.com' });
    Cookies.remove("memberType",{ path: '/',domain: '.cocofax.com' });
    window.location.href = '/'
  }

  const navFun = (e) => {
    setVisible(!visible)
    e.nativeEvent.stopPropagation()
  }

  const handleClickNavList = (e) => {

    e.nativeEvent.stopPropagation()
  }

  useEffect(()=>{
    // 检查token是否过期
    if (Cookies.get('cocofaxToken')) {
      axios.get(buildApi + '/api/user/detailsV2', {
        headers: {
          Authorization: 'Bearer ' + Cookies.get('cocofaxToken'),
        },
        validateStatus: function (status) {
          switch (status) {
            case 401:
                Cookies.remove('cocofaxName',{ path: '/',domain: '.cocofax.com' });
                Cookies.remove('cocofaxToken',{ path: '/',domain: '.cocofax.com' });
                Cookies.remove('memberType',{ path: '/',domain: '.cocofax.com' });
                break;
            default:
                return status >= 200 && status < 300;
          }
        }
      }).then(function (res) {})
      .catch(function (err) {})
    }
  },[])

  useEffect(()=>{
    let title = document.querySelectorAll("header .title")

    let body = document.getElementsByTagName("body")[0]
    body.addEventListener("click", function (e) {
      setVisible(true)
    })

    if (title.length) {
      for (var n = 0; n < title.length; n++) {
        title[n].addEventListener("click", function () {
          this.classList.toggle('actived')

        })
      }
    }

    if(Cookies.get('cocofaxName') && Cookies.get('cocofaxToken')){
        setUserBool(true)
        setUserName(Cookies.get('cocofaxName'))
    }else{
      setUserBool(false)
    }

  },[refreshFlag])

  return (
    <>
      <nav className="h-8 sm:hidden bg-hover-white px-4 py-[3px]">
        <div className="flex justify-between items-center max-w-[1080px] mx-auto">
          <div className="text-xs">Contact Sales: <a href="mailto:sales@cocofax.com" className="underline">sales@cocofax.com</a></div>
          <div className="relative">
            <a href="/login.html" className={`text-xs leading-5 font-semibold ${userBool?'hidden':''}`}>Login</a>
            <a href="/sign-up.html" className={`text-xs leading-5 font-semibold ml-8 ${userBool?'hidden':''}`}>Signup</a>
            <a href={process.env.REACT_APP_CONFIG_APPDOMAIN} className={`username text-xs leading-5 font-semibold ml-8 ${userBool?'':'hidden'}`}>{userName}</a>
            <ul className={`${userBool?'':'hidden'} group`}>
              <li><a href={process.env.REACT_APP_CONFIG_APPDOMAIN} className="flex items-center">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M6 12l-2-1 8-4-6 5zm4.5 1.5L16 7l-2.5 7.5-3-1z" fill="currentColor" opacity=".2"></path><path d="M1 11.048L19 2l-4.5 14.345-6.75-2.207 8.438-9.38-10.238 9.16L1 11.047zm6.75 7.945v-3.752L10 16.345l-2.25 2.648zM6 12l6-5-8 4 2 1zm4.5 1.5l3 1L16 7l-5.5 6.5z" fill="currentColor"></path></svg>
                Send fax</a>
              </li>
              <li><span id="logout-link" onClick={logoutFun} className="hover:cursor-pointer hover:text-blue flex items-center"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M17.2 12.8H11v-1.6h6.2l-1.7-1.7 1-1 3.6 3.5-3.6 3.5-1-1 1.7-1.8zm0 5.6h1.6v2.4c0 .5-.5 1-1 1H5.2a1 1 0 01-1-1V3.1c0-.5.5-1 1-1h12.6c.5 0 1 .5 1 1v2.4h-1.6V4c0-.1 0-.3-.2-.3H6l-.3.3v16l.3.3h11l.3-.3v-1.6z" /></svg>
              Sign out</span>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <header className="sticky left-0 top-0 w-full bg-white z-10 shadow-block">
        <div className="w-full max-w-[1112px] px-[14px]  mx-auto">
          <nav className="flex items-center justify-between">
            <div className={`bread-nav hidden lg:flex ${visible ? '' : 'lg:transform lg:rotate-90'} transition-all duration-200`} onClick={navFun}>
              <svg width="24" height="24" fill="none"> <path d="M7 8H17M7 12H17M7 16H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
            </div>
            <a href="/" className="logo flex items-center h-[48px]">
              <svg width="95" height="20" viewBox="0 0 95 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M63.2467 3.89853C62.6905 3.89853 62.23 4.06319 61.865 4.39252C61.5001 4.72185 61.3176 5.22474 61.3176 5.9012V6.22163H63.8984V9.77303H61.3176V19.7864H56.5992V9.77303H54.1748V6.22163H56.5992V5.8478C56.5992 4.01423 57.0641 2.58122 57.9939 1.54873C58.9236 0.516239 60.2748 0 62.0475 0C63.0555 0 63.8723 0.124609 64.498 0.373832V4.08545C63.994 3.96084 63.5769 3.89853 63.2467 3.89853ZM78.8758 6.22163V19.7864H74.2356V17.9439C73.8533 18.5848 73.2971 19.0877 72.5672 19.4526C71.8373 19.8175 71.0379 20 70.1689 20C69.0392 20 68.0313 19.7152 67.1449 19.1455C66.2586 18.5759 65.5678 17.7615 65.0725 16.7023C64.5772 15.6431 64.3295 14.4192 64.3295 13.0307C64.3295 11.6244 64.5815 10.3783 65.0855 9.29239C65.5895 8.20649 66.2847 7.36093 67.171 6.75567C68.0573 6.15042 69.0566 5.8478 70.1689 5.8478C71.0379 5.8478 71.8329 6.03916 72.5542 6.4219C73.2754 6.80463 73.8359 7.31642 74.2356 7.95728V6.22163H78.8758ZM71.6287 16.3952C72.4629 16.3952 73.106 16.1015 73.5578 15.514C74.0097 14.9266 74.2356 14.081 74.2356 12.9773C74.2356 11.8558 74.0097 10.9969 73.5578 10.4005C73.106 9.80418 72.4629 9.50601 71.6287 9.50601C70.8119 9.50601 70.1689 9.81308 69.6997 10.4272C69.2304 11.0414 68.9958 11.9092 68.9958 13.0307C68.9958 14.1166 69.2217 14.9488 69.6736 15.5274C70.1254 16.1059 70.7772 16.3952 71.6287 16.3952ZM89.3434 12.7904L95.0002 19.7864H89.4737L86.6583 16.1549L83.8429 19.7864H78.3424L83.9993 12.7904L78.6813 6.22163H84.2078L86.6583 9.47931L89.0827 6.22163H94.6613L89.3434 12.7904Z" fill="#3ECF8E" />
                <path fillRule="evenodd" clipRule="evenodd" d="M1.90301 18.1308C3.17169 19.377 4.92695 20 7.16887 20C8.24637 20 9.25869 19.8576 10.2059 19.5728C11.153 19.2879 11.9133 18.8874 12.4869 18.3712L11.2877 15.0868C10.8185 15.4784 10.2754 15.7899 9.65842 16.0214C9.04146 16.2528 8.44623 16.3685 7.87272 16.3685C6.88211 16.3685 6.12612 16.0792 5.60475 15.5007C5.08337 14.9221 4.82269 14.0632 4.82269 12.9239C4.82269 11.8024 5.08337 10.9568 5.60475 10.3872C6.12612 9.81753 6.87342 9.53271 7.84665 9.53271C8.42016 9.53271 9.01973 9.64842 9.64538 9.87984C10.271 10.1113 10.8185 10.4228 11.2877 10.8144L12.4869 7.47664C11.9307 6.97819 11.1834 6.58211 10.245 6.28838C9.30649 5.99466 8.35065 5.8478 7.37741 5.8478C5.91757 5.8478 4.63153 6.14597 3.51926 6.74232C2.407 7.33868 1.5424 8.17979 0.925435 9.26569C0.308475 10.3516 0 11.6066 0 13.0307C0 15.1847 0.63433 16.8847 1.90301 18.1308ZM15.8377 19.1455C16.9326 19.7152 18.2186 20 19.6958 20C21.1557 20 22.4287 19.7107 23.5149 19.1322C24.6011 18.5536 25.4396 17.7348 26.0305 16.6756C26.6214 15.6164 26.9168 14.3658 26.9168 12.9239C26.9168 11.482 26.6214 10.2314 26.0305 9.17223C25.4396 8.11303 24.6011 7.29417 23.5149 6.71562C22.4287 6.13707 21.1557 5.8478 19.6958 5.8478C18.2186 5.8478 16.9326 6.13262 15.8377 6.70227C14.7428 7.27192 13.8999 8.09078 13.309 9.15888C12.7181 10.227 12.4227 11.482 12.4227 12.9239C12.4227 14.3658 12.7181 15.6208 13.309 16.6889C13.8999 17.757 14.7428 18.5759 15.8377 19.1455ZM19.6958 16.3952C21.399 16.3952 22.2506 15.2381 22.2506 12.9239C22.2506 11.749 22.0377 10.8812 21.6119 10.3204C21.1861 9.75968 20.5474 9.47931 19.6958 9.47931C18.8269 9.47931 18.1752 9.75968 17.7407 10.3204C17.3062 10.8812 17.089 11.749 17.089 12.9239C17.089 14.1166 17.3062 14.9933 17.7407 15.5541C18.1752 16.1148 18.8269 16.3952 19.6958 16.3952ZM29.4335 18.1308C30.7021 19.377 32.4574 20 34.6993 20C35.7768 20 36.7891 19.8576 37.7363 19.5728C38.6835 19.2879 39.4438 18.8874 40.0173 18.3712L38.8182 15.0868C38.3489 15.4784 37.8058 15.7899 37.1889 16.0214C36.5719 16.2528 35.9767 16.3685 35.4032 16.3685C34.4126 16.3685 33.6566 16.0792 33.1352 15.5007C32.6138 14.9221 32.3531 14.0632 32.3531 12.9239C32.3531 11.8024 32.6138 10.9568 33.1352 10.3872C33.6566 9.81753 34.4039 9.53271 35.3771 9.53271C35.9506 9.53271 36.5502 9.64842 37.1758 9.87984C37.8015 10.1113 38.3489 10.4228 38.8182 10.8144L40.0173 7.47664C39.4612 6.97819 38.7139 6.58211 37.7754 6.28838C36.8369 5.99466 35.8811 5.8478 34.9079 5.8478C33.448 5.8478 32.162 6.14597 31.0497 6.74232C29.9374 7.33868 29.0728 8.17979 28.4559 9.26569C27.8389 10.3516 27.5304 11.6066 27.5304 13.0307C27.5304 15.1847 28.1648 16.8847 29.4335 18.1308ZM47.2263 20C45.7491 20 44.463 19.7152 43.3681 19.1455C42.2732 18.5759 41.4304 17.757 40.8395 16.6889C40.2486 15.6208 39.9531 14.3658 39.9531 12.9239C39.9531 11.482 40.2486 10.227 40.8395 9.15888C41.4304 8.09078 42.2732 7.27192 43.3681 6.70227C44.463 6.13262 45.7491 5.8478 47.2263 5.8478C48.6861 5.8478 49.9591 6.13707 51.0453 6.71562C52.1315 7.29417 52.9701 8.11303 53.561 9.17223C54.1518 10.2314 54.4473 11.482 54.4473 12.9239C54.4473 14.3658 54.1518 15.6164 53.561 16.6756C52.9701 17.7348 52.1315 18.5536 51.0453 19.1322C49.9591 19.7107 48.6861 20 47.2263 20ZM49.781 12.9239C49.781 15.2381 48.9294 16.3952 47.2263 16.3952C46.3573 16.3952 45.7056 16.1148 45.2711 15.5541C44.8367 14.9933 44.6194 14.1166 44.6194 12.9239C44.6194 11.749 44.8367 10.8812 45.2711 10.3204C45.7056 9.75968 46.3573 9.47931 47.2263 9.47931C48.0779 9.47931 48.7165 9.75968 49.1423 10.3204C49.5681 10.8812 49.781 11.749 49.781 12.9239Z" fill="#0099FF" />
              </svg>
            </a>
            <div className="hidden lg:block w-6"></div>
            <ul onClick={handleClickNavList} className={`flex items-center lg:items-start text-sm bg-white lg:absolute lg:top-[48px] lg:right-0 lg:flex-col lg:h-[calc(100vh-48px)] lg:overflow-x-hidden lg:overflow-y-scroll lg:pb-12 lg:w-full ${visible ? 'lg:hidden' : ''} lg:border-t lg:border-t-[#E8EAF2]`}>
              <li className="lg:w-full">
                <a href="/why-cocofax.html" className="flex items-center h-[28px] px-4 py-1 hover:bg-[#F3F8FA] lg:hover:bg-hover-white hover:text-black rounded-full lg:py-3 lg:px-[14px] font-semibold text-xs lg:h-auto lg:rounded-none">
                  WHY COCOFAX
                </a>
              </li>
              <li className="lg:w-full">
                <span className="title flex items-center h-[52px] p-7 pr-10 font-semibold text-xs cursor-default lg:px-[14px] lg:py-3 lg:h-auto lg:border-t lg:border-t-[#E9EEF7]">
                  PRODUCTS
                </span>
                <div className="pull products w-[900px] rounded-[4px] drop-shadow-headerMenu absolute top-14 left-[-280px] bg-white hidden z-[-1] lg:static lg:block lg:before:hidden lg:min-h-0 lg:w-auto lg:drop-shadow-none">
                  <div className="grid grid-cols-2 mt-2 lg:hidden">
                    <div className="pl-6 text-gray-dark text-sm leading-6 font-semibold">
                      Apps
                    </div>
                    <div className="pl-6 text-gray-dark text-sm leading-6 font-semibold">
                      Integrations
                    </div>
                  </div>
                  <div className="flex mt-2 lg:flex-col lg:mt-0">
                    <div className="grid grid-cols-1 lg:block">
                      <div className="text-xs leading-6 font-semibold hidden p-1 pl-4 text-gray-dark lg:block">
                        Apps
                      </div>
                      <a href="https://app.cocofax.com" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <WebApp className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Web App
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Fax directly from any browser without installation
                          </p>
                        </div>
                      </a>
                      <a href="/fax-software/windows-fax.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <Windows className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Windows Software
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Send and receive faxes with your computer on the go
                          </p>
                        </div>
                      </a>
                      <a href="/fax-software/mac-fax.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <MacApp className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Mac App
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Turn your Mac into a portable fax machine
                          </p>
                        </div>
                      </a>
                      <a href="/fax-software/android-fax.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <AndroidApp className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Android App
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Fax online at your fingertips with an Android phone
                          </p>
                        </div>
                      </a>
                      <a href="/email-to-fax.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <EmailFax className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Email to Fax
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Exchange fax messages securely and easily like emailing
                          </p>
                        </div>
                      </a>
                    </div>
                    <div className="hidden lg:block w-[calc(100vw-28px)] ml-[14px] mt-2 mb-4 border-t border-t-[#E9EEF7]"></div>
                    <div className="grid grid-cols-1 lg:block">
                      <div className="text-xs leading-6 font-semibold hidden p-1 pl-4 text-gray-dark lg:block">
                        Integrations
                      </div>
                      <a href="/google-integration.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <Google className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Google Integration
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Fax from Google Docs, Sheets, Drive, and Gmail within seconds
                          </p>
                        </div>
                      </a>
                      <a href="/fax-software/microsoft-intergration-fax.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <Microsoft className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Microsoft Integration
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Draft a document and fax with CocoFax’s Microsoft add-on right away
                          </p>
                        </div>
                      </a>
                      <a href="/slack-integration.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <Slack className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Slack Integration
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Instant alerts on your Slack for any fax messages received
                          </p>
                        </div>
                      </a>
                      <a href="https://chrome.google.com/webstore/detail/cocofax-fax-from-google/aamhfladfpacdednbomhcfgapoljdjgo" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <Chrome className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Chrome Extension
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Add CocoFax to your Chrome and jumpstart your business efficiency
                          </p>
                        </div>
                      </a>
                      <a href="/developers/api.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                        <FaxApi className="w-8 mt-[6px] lg:flex-shrink-0" />
                        <div className="ml-[14px]">
                          <div className="font-semibold text-sm text-black leading-6">
                            Fax API
                          </div>
                          <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                            Integrate CocoFax API into your business system to enhance workflow
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  <p className="py-3 border-t border-t-[#E9EEF7] lg:border-t-0">
                    <a href="/features.html" className="flex items-center justify-center text-gray-dark font-semibold text-sm leading-6 lg:justify-start lg:p-1 lg:pl-4">
                      View All Features
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 12H8M16 12L13 9M16 12L13 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </a>
                  </p>
                </div>
              </li>
              {/* <li className="lg:w-full">
                <a href="/features.html" className="flex items-center h-[28px] px-4 py-1 hover:bg-[#F3F8FA] lg:hover:bg-hover-white hover:text-black rounded-full lg:py-3 lg:px-[14px] font-semibold text-xs lg:h-auto lg:rounded-none lg:mt-4">
                  FEATURES
                </a>
              </li> */}
              {/* <li className="lg:w-full">
              <span className="flex items-center h-[52px] p-7 pr-10 font-semibold text-xs cursor-default lg:px-[14px] lg:py-3 lg:h-auto">
                HOW IT WORKS
              </span>
              <div className="pull w-[900px] min-h-[192px] rounded-[4px] drop-shadow-headerMenu absolute top-14 left-[-510px] bg-white hidden z-[-1] lg:static lg:block lg:before:hidden lg:min-h-0 lg:w-auto lg:shadow-none">
                <div className="text-gray-dark text-sm leading-6 font-semibold mt-2 ml-6 lg:hidden">
                  How it Works
                </div>
                <div className="grid grid-cols-2 mt-2 lg:block">
                  <a href="#" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                    <Computer className="w-8 mt-[6px] lg:flex-shrink-0" />
                    <div className="ml-[14px]">
                      <div className="font-semibold text-sm text-black leading-6">
                        Fax from Computer
                      </div>
                      <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                        Finally, enable your fast-moving teams with a simple
                      </p>
                    </div>
                  </a>
                  <a href="#" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                    <Gmail className="w-8 mt-[6px] lg:flex-shrink-0" />
                    <div className="ml-[14px]">
                      <div className="font-semibold text-sm text-black leading-6">
                        Send Fax from Gmail
                      </div>
                      <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                        Finally, enable your fast-moving teams with a simple
                      </p>
                    </div>
                  </a>
                  <a href="#" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                    <Google className="w-8 mt-[6px] lg:flex-shrink-0" />
                    <div className="ml-[14px]">
                      <div className="font-semibold text-sm text-black leading-6">
                        Google to Fax
                      </div>
                      <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                        Finally, enable your fast-moving teams with a simple
                      </p>
                    </div>
                  </a>
                  <a href="#" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                    <EmailFax className="w-8 mt-[6px] lg:flex-shrink-0" />
                    <div className="ml-[14px]">
                      <div className="font-semibold text-sm text-black leading-6">
                        Email to Fax
                      </div>
                      <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                        Finally, enable your fast-moving teams with a simple
                      </p>
                    </div>
                  </a>
                  <a href="#" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                    <GooglePlay className="w-8 mt-[6px] lg:flex-shrink-0" />
                    <div className="ml-[14px]">
                      <div className="font-semibold text-sm text-black leading-6">
                        Google Play
                      </div>
                      <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">
                        Finally, enable your fast-moving teams with a simple
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </li> */}
              <li className="lg:w-full">
                <span className="title flex items-center h-[52px] p-7 pr-10 font-semibold text-xs cursor-default lg:px-[14px] lg:py-3 lg:h-auto lg:border-t lg:border-t-[#E9EEF7]">
                  INDUSTRY
                </span>
                <div className="pull industry w-[900px] rounded-[4px] drop-shadow-headerMenu absolute top-14 left-[-510px] bg-white hidden z-[-1] lg:static lg:block lg:before:hidden lg:min-h-0 lg:w-auto lg:drop-shadow-none">
                  <div className="text-gray-dark text-sm leading-6 font-semibold mt-2 ml-6 lg:hidden">Industry</div>
                  <div className="grid grid-cols-2 mt-2 lg:block">

                    <a href="/online-fax-solutions/legal.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                      <Legal className="w-8 mt-[6px] lg:flex-shrink-0" />
                      <div className="ml-[14px]">
                        <div className="font-semibold text-sm text-black leading-6">Legal</div>
                        <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">Secure your confidential documents with military-grade encryption measures</p>
                      </div>
                    </a>

                    <a href="/online-fax-solutions/education.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                      <Education className="w-8 mt-[6px] lg:flex-shrink-0" />
                      <div className="ml-[14px]">
                        <div className="font-semibold text-sm text-black leading-6">Education</div>
                        <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">Employ a more affordable faxing infrastructure for your institution</p>
                      </div>
                    </a>
                    <a href="/online-fax-solutions/finance.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                      <Financial className="w-8 mt-[6px] lg:flex-shrink-0" />
                      <div className="ml-[14px]">
                        <div className="font-semibold text-sm text-black leading-6">Financial services</div>
                        <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">Automate your document delivery and improve your data security</p>
                      </div>
                    </a>
                    <a href="/online-fax-solutions/healthcare.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                      <Healthcare className="w-8 mt-[6px] lg:flex-shrink-0" />
                      <div className="ml-[14px]">
                        <div className="font-semibold text-sm text-black leading-6">Healthcare</div>
                        <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">Bring your institution into alignment with premium security standards</p>
                      </div>
                    </a>
                    <a href="/online-fax-solutions/manufacturing.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                      <Manufacturing className="w-8 mt-[6px] lg:flex-shrink-0" />
                      <div className="ml-[14px]">
                        <div className="font-semibold text-sm text-black leading-6">Manufacturing</div>
                        <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">Lower cost by eliminating toner, paper and hardware costs</p>
                      </div>
                    </a>
                    <a href="/online-fax-solutions/insurance.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                      <Insurance className="w-8 mt-[6px] lg:flex-shrink-0" />
                      <div className="ml-[14px]">
                        <div className="font-semibold text-sm text-black leading-6">Insurance</div>
                        <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">Fax insurance documents quickly, easily and safely on the cloud</p>
                      </div>
                    </a>
                    <a href="/online-fax-solutions/high-tech.html" className="w-[446px] flex items-start py-3 px-6 hover:bg-hover-white lg:pl-[14px] lg:pr-[15px] lg:py-3 lg:min-h-0 lg:w-full">
                      <SoftwareTech className="w-8 mt-[6px] lg:flex-shrink-0" />
                      <div className="ml-[14px]">
                        <div className="font-semibold text-sm text-black leading-6">Software and technology</div>
                        <p className="text-xs text-gray-dark leading-5 w-[344px] lg:w-full">Enhance compliance with security and privacy regulations</p>
                      </div>
                    </a>
                  </div>
                  <p className="py-3 border-t border-t-[#E9EEF7] lg:border-t-0">
                    <a href="/online-fax-solutions.html" className="flex items-center justify-center text-gray-dark font-semibold text-sm leading-6 lg:justify-start lg:p-1 lg:pl-4">
                      All industries
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 12H8M16 12L13 9M16 12L13 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </a>
                  </p>
                </div>
              </li>
              <li className="lg:w-full">
                <span className="title flex items-center h-[52px] p-7 pr-10 font-semibold text-xs cursor-default lg:px-[14px] lg:py-3 lg:h-auto lg:border-t lg:border-t-[#E9EEF7]">
                  RESOURCES
                </span>
                <div className="pull resources w-[256px] pb-6 rounded-[4px] drop-shadow-headerMenu absolute top-14 left-[-40px] bg-white hidden z-[-1] lg:static lg:block lg:pb-0 lg:before:hidden lg:min-h-0 lg:w-auto lg:drop-shadow-none">
                  <div className="text-gray-dark text-sm leading-6 font-semibold pt-2 pl-6 pb-[10px] border-b border-b-[#E9EEF7] lg:hidden">Resources</div>
                  <ul className="pt-1.5 font-sm leading-6 font-semibold lg:pt-0 lg:pb-4">
                    <li className="hover:bg-hover-white"><a href="/security-overview.html" className="flex items-center px-6 py-2 hover:text-gray-dark lg:pl-4 lg:pr-[15px]"><Security className="w-8 mr-[14px] lg:flex-shrink-0"/>Security Overview</a></li>
                    <li className="hover:bg-hover-white"><a href="/hipaa-compliant-fax.html" className="flex items-center px-6 py-2 hover:text-gray-dark lg:pl-4 lg:pr-[15px]"><HipaaFax className="w-8 mr-[14px] lg:flex-shrink-0"/>HIPAA Fax</a></li>
                    <li className="hover:bg-hover-white"><a href="/help/" className="flex items-center px-6 py-2 hover:text-gray-dark lg:pl-4 lg:pr-[15px]"><HelpCenter className="w-8 mr-[14px] lg:flex-shrink-0"/>Help Center</a></li>
                    <li className="hover:bg-hover-white"><a href="/customer-stories.html" className="flex items-center px-6 py-2 hover:text-gray-dark lg:pl-4 lg:pr-[15px]"><CustomerStories className="w-8 mr-[14px] lg:flex-shrink-0"/>Customer Stories</a></li>
                    <li className="hover:bg-hover-white"><a href="/faq.html" className="flex items-center px-6 py-2 hover:text-gray-dark lg:pl-4 lg:pr-[15px]"><FAQs className="w-8 mr-[14px] lg:flex-shrink-0"/>FAQs</a></li>
                    <li className="hover:bg-hover-white"><a href="/contact.html" className="flex items-center px-6 py-2 hover:text-gray-dark lg:pl-4 lg:pr-[15px]"><ContactSales className="w-8 mr-[14px] lg:flex-shrink-0"/>Contact Sales</a></li>
                  </ul>
                </div>
              </li>
              <li className="lg:w-full">
                <a href="/pricing.html" className="flex items-center h-[28px] px-4 py-1 hover:bg-[#F3F8FA] lg:hover:bg-hover-white hover:text-black rounded-full lg:py-3 lg:px-[14px] font-semibold text-xs lg:h-auto lg:rounded-none lg:border-t lg:border-t-[#E9EEF7]">
                  PRICING
                </a>
              </li>
              <li className="lg:px-[14px]">
                <a
                  href="/choose-fax-number.html"
                  className="flex items-center justify-center ml-8 lg:ml-0 font-bold text-xs text-white bg-green hover:bg-hover-green hover:text-white rounded-3xl h-8 w-[120px] shadow-lightButton lg:mt-3"
                >
                  Start Faxing
                </a>
              </li>
              <li className={`hidden px-6 mt-4 lg:block lg:w-full ${userBool?'lg:hidden':''}`}>
                <a href="/login.html" className="text-sm leading-5 font-semibold hover:text-white lg:hover:text-black">Login</a>
                <a href="/sign-up.html" className="text-sm leading-5 font-semibold hover:text-white lg:hover:text-black ml-8">Signup</a>
              </li>

              
            </ul>
          </nav>
        </div>
      </header>
    </>
  )
}

export default Header
